import { render, staticRenderFns } from "./ProjectActivityTask.vue?vue&type=template&id=3272d739&"
import script from "./ProjectActivityTask.vue?vue&type=script&lang=js&"
export * from "./ProjectActivityTask.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActivityTask.vue?vue&type=style&index=0&id=3272d739&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports